import ConfirmAndSendModal from '../presentational/ConfirmAndSendModal';

const ConfirmAndSendModalContainer = ({
    selectedPayee,
    form,
    handleSubmit,
    error,
    hideModal,
    isPosting,
    type,
}) => {

    const handleClose = () => hideModal();

    return (
        <ConfirmAndSendModal
            {...form}
            selectedPayee={selectedPayee}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            isPosting={isPosting}
            isError={error}
            type={type}
        />
    );
};

export default ConfirmAndSendModalContainer;
